import { api } from "../App";
import { createNotification } from "../components/Notifications/Notifications";
import { SET_ADMISSION_DISCIPLINES, SET_ADMISSION_BY_ID, SET_ADMISSIONS_LIST, SET_ADMISSIONS_LOADING } from "./types";

const DEFAULT_ERROR_MESSAGE = 'Что-то пошло не так';

const getErrorMessage = (error) => {
  return error?.response?.data?.error
    || error?.response?.data?.message
    || DEFAULT_ERROR_MESSAGE;
};

const handleError = (error) => {
  createNotification('error', getErrorMessage(error));
};

export const getAdmissionsList = () => async (dispatch) => {
  try {
    dispatch({ type: SET_ADMISSIONS_LOADING, payload: true });
    const { data } = await api.get('/enroll_comitet');
    dispatch({ type: SET_ADMISSIONS_LIST, payload: data });
  } catch (error) {
    handleError(error);
  } finally {
    dispatch({ type: SET_ADMISSIONS_LOADING, payload: false });
  }
};

export const createAdmissionComitet = (payload) => async (dispatch) => {
  try {
    await api.post('/enroll_comitet', payload);
    await dispatch(getAdmissionsList());
    createNotification('success', "Комиссия успешно создана");
    return true;
  } catch (error) {
    handleError(error);
    return false;
  }
};

export const updateAdmissionComitet = ({ id, ...payload }) => async (dispatch) => {
  try {
    await api.put(`/enroll_comitet/${id}`, payload);
    await dispatch(getAdmissionsList());
    createNotification('success', "Комиссия успешно обновлена");
    return true;
  } catch (error) {
    handleError(error);
    return false;
  }
};

export const deleteAdmissionComitet = (id) => async (dispatch) => {
  try {
    await api.delete(`/enroll_comitet/${id}`);
    await dispatch(getAdmissionsList());
    createNotification('success', "Комиссия удалена");
    return true;
  } catch (error) {
    handleError(error);
    return false;
  }
};

export const getAdmissionById = (id) => async (dispatch) => {
  try {
    dispatch({ type: SET_ADMISSIONS_LOADING, payload: true });
    const { data } = await api.get(`/enroll_comitet/${id}`);
    dispatch({ type: SET_ADMISSION_BY_ID, payload: data });
  } catch (error) {
    handleError(error);
  } finally {
    dispatch({ type: SET_ADMISSIONS_LOADING, payload: false });
  }
};

// ЧЛЕНЫ КОМИССИИ
export const createAdmissionComitetMember = ({ id, ...payload }) => async (dispatch) => {
  try {
    await api.post(`/enroll_comitet/${id}/members`, payload);
    await dispatch(getAdmissionById(id));
    createNotification('success', "Член комиссии добавлен");
    return true;
  } catch (error) {
    handleError(error);
    return false;
  }
};

export const deleteAdmissionComitetMember = ({ id, mid }) => async (dispatch) => {
  try {
    await api.delete(`/enroll_comitet/${id}/members/${mid}`);
    await dispatch(getAdmissionById(id));
    createNotification('success', "Член комиссии удалён");
    return true;
  } catch (error) {
    handleError(error);
    return false;
  }
};

// Получение дисциплин для тестирования
export const getAdmissionDisciplines = (params) => async (dispatch) => {
  const urlParams = new URLSearchParams(params).toString();
  try {
    dispatch({ type: SET_ADMISSIONS_LOADING, payload: true });
    const { data } = await api.get(`/enroll_comitet/disciplines?${urlParams}`);
    dispatch({ type: SET_ADMISSION_DISCIPLINES, payload: data });
  } catch (error) {
    handleError(error);
  } finally {
    dispatch({ type: SET_ADMISSIONS_LOADING, payload: false });
  }
};

export const createAdmissionDisciplines = ({ id_enroll_comitet, ...payload }) => async (dispatch) => {
  try {
    await api.post(`/enroll_comitet/disciplines`, payload);
    createNotification('success', 'Дисциплина добавлена');
    return true;
  } catch (error) {
    handleError(error);
    return false;
  } finally {
    await dispatch(getAdmissionById(id_enroll_comitet));
  }
};